import React, { Component } from 'react';
import { Carousel } from 'react-bootstrap';
import './QuoteCarousel.css';

class QuoteCarousel extends Component {
  render() {
    const quoteHTML = this.props.quotes.map((quote, i) => {
      return (
        <Carousel.Item className="carousel-item" key={i}>
          <div className="quote">
            <p className="content"> {quote.content}</p>
            <p className="author">
              {quote.author}
            </p>
          </div>
        </Carousel.Item>
      );
    });

    return (

      <Carousel controls={false} className="carousel" >
        {quoteHTML}
      </Carousel >

    );
  }
}
export default QuoteCarousel;



// WEBPACK FOOTER //
// ./src/components/common/QuoteCarousel.js